var map = {
	"./SpinGeneral_001.webp": 3585,
	"./SpinGeneral_002.webp": 9485,
	"./SpinGeneral_003.webp": 9129,
	"./SpinGeneral_004.webp": 1702,
	"./SpinGeneral_005.webp": 878,
	"./SpinGeneral_006.webp": 8201,
	"./SpinGeneral_007.webp": 1748,
	"./SpinGeneral_008.webp": 669,
	"./SpinGeneral_009.webp": 6458,
	"./SpinGeneral_010.webp": 9913,
	"./SpinGeneral_011.webp": 2649,
	"./SpinGeneral_012.webp": 8618,
	"./SpinGeneral_013.webp": 7535,
	"./SpinGeneral_014.webp": 844,
	"./SpinGeneral_015.webp": 7817,
	"./SpinGeneral_016.webp": 1103,
	"./SpinGeneral_017.webp": 4908,
	"./SpinGeneral_018.webp": 1671,
	"./SpinGeneral_019.webp": 5569,
	"./SpinGeneral_020.webp": 9630,
	"./SpinGeneral_021.webp": 2864,
	"./SpinGeneral_022.webp": 4132,
	"./SpinGeneral_023.webp": 359,
	"./SpinGeneral_024.webp": 661,
	"./SpinGeneral_025.webp": 8043,
	"./SpinGeneral_026.webp": 7189,
	"./SpinGeneral_027.webp": 7797,
	"./SpinGeneral_028.webp": 988,
	"./SpinGeneral_029.webp": 5837,
	"./SpinGeneral_030.webp": 9248,
	"./SpinGeneral_031.webp": 5674,
	"./SpinGeneral_032.webp": 6149,
	"./SpinGeneral_033.webp": 8916,
	"./SpinGeneral_034.webp": 127,
	"./SpinGeneral_035.webp": 4658,
	"./SpinGeneral_036.webp": 5024,
	"./SpinGeneral_037.webp": 6970,
	"./SpinGeneral_038.webp": 270,
	"./SpinGeneral_039.webp": 6146,
	"./SpinGeneral_040.webp": 4832,
	"./SpinGeneral_041.webp": 493,
	"./SpinGeneral_042.webp": 3495,
	"./SpinGeneral_043.webp": 2225,
	"./SpinGeneral_044.webp": 2279,
	"./SpinGeneral_045.webp": 697,
	"./SpinGeneral_046.webp": 5192,
	"./SpinGeneral_047.webp": 281,
	"./SpinGeneral_048.webp": 1318,
	"./SpinGeneral_049.webp": 248,
	"./SpinGeneral_050.webp": 3820,
	"./SpinGeneral_051.webp": 5119,
	"./SpinGeneral_052.webp": 9159,
	"./SpinGeneral_053.webp": 5718,
	"./SpinGeneral_054.webp": 468,
	"./SpinGeneral_055.webp": 9765,
	"./SpinGeneral_056.webp": 3562,
	"./SpinGeneral_057.webp": 2762,
	"./SpinGeneral_058.webp": 6521,
	"./SpinGeneral_059.webp": 1237,
	"./SpinGeneral_060.webp": 1888,
	"./SpinGeneral_061.webp": 7199,
	"./SpinGeneral_062.webp": 5902,
	"./SpinGeneral_063.webp": 9321,
	"./SpinGeneral_064.webp": 5730,
	"./SpinGeneral_065.webp": 634,
	"./SpinGeneral_066.webp": 6573,
	"./SpinGeneral_067.webp": 3182,
	"./SpinGeneral_068.webp": 2355,
	"./SpinGeneral_069.webp": 6026,
	"./SpinGeneral_070.webp": 7697,
	"./SpinGeneral_071.webp": 1700,
	"./SpinGeneral_072.webp": 5412
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8748;